import './reset.scss';

import DefaultPage from 'keycloakify/login/DefaultPage';
import type { PageProps } from 'keycloakify/login/pages/PageProps';
import type { UserProfileFormFieldsProps } from 'keycloakify/login/UserProfileFormFieldsProps';
import React from 'react';

import { i18n as fallbackI18n } from './i18n'; // ✅ jouw bestaande i18n
import type { KcContext } from './kcContext';
import Login from './login/Login';
import LoginConfigTotp from './login/LoginConfigTotp';
import LoginOtp from './login/LoginOtp';
import Template from './Template';

export default function KcApp(
  props: Omit<PageProps<KcContext, any>, 'Template' | 'doUseDefaultCss'>
) {
  const { kcContext } = props;

  const i18n = (props as any).i18n ?? fallbackI18n;

  switch (kcContext.pageId) {
    case 'login.ftl':
      return <Login kcContext={kcContext} i18n={i18n} />;

    case 'login-otp.ftl':
      return <LoginOtp kcContext={kcContext} i18n={i18n} />;

    case 'login-config-totp.ftl':
      return <LoginConfigTotp kcContext={kcContext} i18n={i18n} />;

    default:
      return (
        <DefaultPage
          kcContext={kcContext}
          i18n={i18n}
          Template={Template}
          doUseDefaultCss={true}
          UserProfileFormFields={function UserProfileFormFields(
            _props: UserProfileFormFieldsProps<any, any>
          ): React.ReactElement {
            return <div />;
          }}
          doMakeUserConfirmPassword={false}
        />
      );
  }
}
